import React, { useState, useEffect } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Card } from "reactstrap";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Repository from "../../../../configs/axios/repository";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import x_letter from "../../../../assets/icons/x_ letter.png";
import testBluePng from "../../../../assets/images/notes/notesModal.svg";
import x_mark from "../../../../assets/images/courses/group.svg";
import Modal from "react-modal";

const customStyles = {
    content: {
        top: "50%",
        left: "58%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        background: "#F9FAFC 0% 0% no-repeat padding-box",
        padding: "20px 30px",
        width: "60%",
        zIndex: "9000",
        maxHeight: "600px",
    },
};
const FreeTest = (props) => {
    const history = useHistory();
    const location = useLocation();
    const [loadingData, setLoadingData] = useState(true);
    const [countTest, setCountTest] = useState(0);
    const [isSelectedAnswer, setIsSelectedAnswer] = useState(false);
    const [showSelectionText, setShowSelectionText] = useState(false);
    const [userAnswer, setUserAnswer] = useState("");
    const [isAnswer, setIsAnswer] = useState(true);
    const [allOfAbove, setAlOfAbove] = useState(false);
    const [noneOfAbove, setNoneOfAbove] = useState(false);
    const [modalIsOpen, setIsOpen] = React.useState(false);

    let testData = location.state?.testData;
    const [answerId, setAnswerId] = useState(0);

    const testType = location.state?.testType;
    const note_id = location.state?.note_id;
    const isData = location.state?.isData;
    const noteData = location.state?.noteData;
    const canDoIt = location.state?.canDoIt;
    let notes = testData?.test_prompt;
    let array = location.state?.array;

    function scoreFunc() {
        let countRightAnswer = 0;
        for (let i = 0; i < array.length; i++) {
            for (let j = 0; j < array[i].answers.length; j++) {
                if (
                    array[i].answers[j].correct == true &&
                    array[i].answers[j].correct ==
                        array[i].answers[j].isSelected
                ) {
                    countRightAnswer = countRightAnswer + 1;
                }
            }
        }
        let returnedData = JSON.stringify({
            questions_count: array.length,
            count_right_nswer: countRightAnswer,
            right_percentage:
                " (" +
                Math.floor((100 * countRightAnswer) / array.length) +
                "%)",
        });
        return returnedData;
    }
    function scoreNumber() {
        let countRightAnswer = 0;
        for (let i = 0; i < array.length; i++) {
            for (let j = 0; j < array[i].answers.length; j++) {
                if (
                    array[i].answers[j].correct == true &&
                    array[i].answers[j].correct ==
                        array[i].answers[j].isSelected
                ) {
                    countRightAnswer = countRightAnswer + 1;
                }
            }
        }

        return Math.floor((100 * countRightAnswer) / array.length);
    }

    const nextTestAbove = async (item) => {
        setShowSelectionText(false);
        setIsSelectedAnswer(false);
        selectedAbove(item);

        if (countTest >= array.length - 1) {
            let score = scoreNumber();
            let scoreData = scoreFunc();

            history.push({
                pathname: "/resultFreeTest",
                state: {
                    array,
                    testType,
                    note_id,
                    isData,
                    noteData,
                    canDoIt,
                    score,
                    scoreData,
                    testData,
                },
            });
        } else {
            setCountTest(countTest + 1);
        }
    };

    const nextTest = async (item) => {
        setAlOfAbove(false);
        setNoneOfAbove(false);
        if (isSelectedAnswer) {
            setShowSelectionText(false);
            setIsSelectedAnswer(false);
            selectedAnswer(item);
            if (countTest >= array.length - 1) {
                let score = scoreNumber();
                let scoreData = scoreFunc();
                history.push({
                    pathname: "/resultFreeTest",
                    state: {
                        array,
                        testType,
                        note_id,
                        isData,
                        noteData,
                        canDoIt,
                        score,
                        scoreData,
                        testData,
                    },
                });
            } else {
                setCountTest(countTest + 1);
            }
        } else {
            setShowSelectionText(true);
        }
    };
    const skipTest = async (item) => {
        setShowSelectionText(false);
        setIsSelectedAnswer(false);
        notSelectedAnswer(item);
        if (countTest >= array.length - 1) {
            let score = scoreNumber();
            let scoreData = scoreFunc();
            history.push({
                pathname: "/resultFreeTest",
                state: {
                    array,
                    testType,
                    note_id,
                    isData,
                    noteData,
                    canDoIt,
                    score,
                    scoreData,
                    testData,
                },
            });
        } else {
            setCountTest(countTest + 1);
        }
    };
    const backTest = async (item) => {
        setShowSelectionText(false);
        setIsSelectedAnswer(false);
        selectedAnswer(item);
        if (countTest <= 0) {
        } else {
            setCountTest(countTest - 1);
        }
    };

    const nextWrittenTest = async (item) => {
        if (userAnswer != "") {
            setIsAnswer(true);
            enteredAnswer(item);
            if (countTest >= array.length - 1) {
                let score = 1;
                let scoreData = 2;
               
                history.push({
                    pathname: "/resultFreeWrittrnTest",
                    state: {
                        array,
                        testType,
                        note_id,
                        isData,
                        noteData,
                        canDoIt,
                        score,
                        scoreData,
                        testData,
                    },
                });
            } else {
                setUserAnswer("");
                setCountTest(countTest + 1);
            }
        } else {
            setIsAnswer(false);
        }
    };
    const selectedAnswer = async (item) => {
        setAlOfAbove(false);
        setNoneOfAbove(false);
        for (let i = 0; i < array.length; i++) {
            if (array[i].id === item) {
                for (let j = 0; j < array[i].answers.length; j++) {
                    if (array[i].answers[j].id === answerId) {
                        array[i].answers[j].isSelected = true;
                        array[i].answers[j].allOfAbove = false;
                        array[i].answers[j].noneOfAbove = false;
                    } else {
                        array[i].answers[j].isSelected = false;
                        array[i].answers[j].allOfAbove = false;
                        array[i].answers[j].noneOfAbove = false;
                    }
                }
                break;
            }
        }
    };

    const notSelectedAnswer = async (item) => {
        setAlOfAbove(false);
        setNoneOfAbove(false);
        for (let i = 0; i < array.length; i++) {
            if (array[i].id === item) {
                for (let j = 0; j < array[i].answers.length; j++) {
                    array[i].answers[j].isSelected = false;
                    array[i].answers[j].allOfAbove = false;
                    array[i].answers[j].noneOfAbove = false;
                }
                break;
            }
        }
    };

    const selectedAbove = async (item) => {
        if (allOfAbove) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].id === item) {
                    for (let j = 0; j < array[i].answers.length; j++) {
                        array[i].answers[j].allOfAbove = true;
                        array[i].answers[j].noneOfAbove = false;
                    }
                    break;
                }
            }
        } else if (noneOfAbove) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].id === item) {
                    for (let j = 0; j < array[i].answers.length; j++) {
                        array[i].answers[j].noneOfAbove = true;
                        array[i].answers[j].allOfAbove = false;
                    }
                    break;
                }
            }
        }
        setAlOfAbove(false);
        setNoneOfAbove(false);
    };
    const enteredAnswer = async (item) => {
        for (let i = 0; i < array.length; i++) {
            if (array[i].id === item) {
                array[i].userAnswer = userAnswer;
                break;
            }
        }
    };

    function getCharForNumber(i) {
        return i > 0 && i < 27 ? String.fromCharCode(i + 64) : null;
    }
    let answersQuestions;
    if (testType == "choice") {
        answersQuestions = array[countTest].answers?.map((file, i) => {
            return (
                <div key={i * 8}>
                    <div
                        className={
                            allOfAbove
                                ? "answer selectedAnswer"
                                : isSelectedAnswer && answerId == file.id
                                ? "answer selectedAnswer"
                                : "answer"
                        }
                        onClick={() => {
                            setAlOfAbove(false);
                            setIsSelectedAnswer(true);
                            setAnswerId(file.id);
                        }}
                    >
                        <span>{getCharForNumber(i + 1) + ")"} </span>
                        <span>{file.text}</span>
                    </div>
                </div>
            );
        });
    } else {
        answersQuestions = (file, i) => {
            return (
                <div key={i}>
                    <div
                        className={
                            isSelectedAnswer && answerId == file.id
                                ? "answer selectedAnswer"
                                : "answer"
                        }
                        onClick={() => {
                            setIsSelectedAnswer(true);
                            setAnswerId(file.id);
                        }}
                    >
                        <span>{getCharForNumber(i + 1) + ")"} </span>
                        <span>{file.text}</span>
                    </div>
                </div>
            );
        };
    }
    const handleChange = (event) => {
        setUserAnswer(event.target.value);
    };

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    return (
        <div>
            <div className="noteModalIcone">
                <img
                    src={testBluePng}
                    alt="testPng"
                    title="Click to see note"
                    onClick={() => {
                        openModal();
                    }}
                />
            </div>
            {testType == "choice" ? (
                <Card className="homeCard ">
                    <div>
                        <div
                            className="xmarkTest"
                            onClick={() => {
                                history.push({
                                    pathname: "/tryforfree",
                                });
                            }}
                        >
                            <img src={x_mark} alt="x_mark" />
                        </div>
                    </div>

                    <div className="accountingHeaderContent mt-3">
                        <h1 className="mt-4">{testData.test_name}</h1>
                        <p>Question {countTest + 1 + "/" + array?.length} </p>
                    </div>

                    <div className="testContent">
                        {" "}
                        <div className="question">
                            {array[countTest].question}
                        </div>
                        <div className="answerSection accountingCardBody">
                            <div>
                                <div className="accountingContent">
                                    {answersQuestions}
                                    {showSelectionText ? (
                                        <p className="selectOption">
                                            Please select an option.
                                        </p>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="nextBtnDiv">
                        <button
                            className="mt-1"
                            onClick={() => {
                                backTest(array[countTest].id);
                                setAlOfAbove(false);
                                setNoneOfAbove(false);
                            }}
                        >
                            Back
                        </button>

                        <button
                            className={
                                allOfAbove || noneOfAbove
                                    ? "boldNext mt-1"
                                    : "mt-1"
                            }
                            onClick={() => {
                                noneOfAbove || allOfAbove
                                    ? nextTestAbove(array[countTest].id)
                                    : nextTest(array[countTest].id);
                            }}
                        >
                            Next
                        </button>

                        <button
                            className="mt-1"
                            onClick={() => {
                                skipTest(array[countTest].id);
                                setAlOfAbove(false);
                                setNoneOfAbove(false);
                            }}
                        >
                            Skip
                        </button>
                    </div>
                </Card>
            ) : (
                <Card className="homeCard ">
                    <div>
                        <div
                            className="xmarkTest"
                            onClick={() => {
                                history.push({
                                    pathname: "/tryforfree",
                                });
                            }}
                        >
                            <img src={x_mark} alt="x_mark" />
                        </div>
                    </div>

                    <div className="accountingHeaderContent ">
                        <h1 className="mt-4">{testData.test_name}</h1>
                        <p>Question {countTest + 1 + "/" + array?.length} </p>
                    </div>

                    {array[countTest] == undefined ||
                    array[countTest] == null ? (
                        <div className="d-flex justify-content-center mt-5">
                            <h4>There are no questions in this test.</h4>
                        </div>
                    ) : (
                        <div>
                            <div className="testContent">
                                <div className="question">
                                    {array ? array[countTest]?.question : ""}
                                </div>
                                <div className="answerSection accountingCardBody">
                                    <div className="questionContent">
                                        <textarea
                                            value={userAnswer}
                                            onChange={handleChange}
                                            name="notes"
                                            className="textareaWrittenTest"
                                            placeholder="Enter your answer*"
                                        />
                                        {isAnswer ? (
                                            ""
                                        ) : (
                                            <p className="selectOption">
                                                Please select an option.
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="nextBtnDiv">
                                <button
                                    className="mt-4"
                                    onClick={() => {
                                        nextWrittenTest(array[countTest].id);
                                    }}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </Card>
            )}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Example Modal"
            >
                <div className="showNotes">
                    <h2>Note</h2>
                    <img
                        src={x_mark}
                        onClick={closeModal}
                        className="closeModalImg"
                    />
                </div>
                <div>
                    <span className="modalSpanNote">
                        {notes.split("\n").map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                    </span>
                </div>
            </Modal>
        </div>
    );
};

export default FreeTest;
